/**
 * Qatar Oil and Gas - PDF Presentation Configuration
 *
 * Slide-by-slide configuration with:
 * - Page numbers
 * - Pre-scripted narrations for avatar TTS
 */

export const qatarOilGasPresentation = {
  pdfUrl: 'https://storage.googleapis.com/qudemo-test-qudemo/licensed-image.pdf',

  slides: [
    {
      page: 1,
      title: 'Oil and Gas Development',
      narration: `This image represents Qatar's transformation through oil and gas.   The discovery of these resources changed Qatar from a small pearl-diving nation   into one of the world's wealthiest countries.`,
    },
  ],
};

export default qatarOilGasPresentation;
